<template>
  <div
    class="timeline--node align-center"
    data-aos="zoom-in"
    data-aos-once="false"
    @click="onClick"
  >
    <!-- <p class="timeline--node-label">Label</p> -->
  </div>
</template>

<script>
export default {
  name: "Node",
  props: ["item"],
  data: () => ({
    reveal: false,
  }),
  methods: {
    onClick: () => {
      this.reveal = true;
      console.log(this.reveal);
    },
  },
};
</script>
